import { useEffect, useState, RefObject } from 'react'

import { Events } from 'constants/events'

const useToggleAfterScrollBlock = (
  blockRef: RefObject<HTMLDivElement>,
  blockRefOff?: RefObject<HTMLDivElement>,
  topPadding = 127,
  defaultValue?: boolean
) => {
  const [value, setValue] = useState(Boolean(defaultValue))
  const [toggleOff, setToggleOff] = useState(0)

  useEffect(() => {
    const changeValue = () => {
      let scrolledBlock = blockRef?.current?.getBoundingClientRect().top
      if (toggleOff && window.scrollY > toggleOff) {
        setValue(false)
        return
      }

      if (scrolledBlock && window.scrollY > 0) {
        scrolledBlock = scrolledBlock + window.scrollY
      }

      const scrollTop = Number(scrolledBlock) - topPadding

      const isNotInView = window.scrollY >= scrollTop
      setValue(isNotInView)
    }

    window.addEventListener(Events.SCROLL, changeValue)

    if (blockRefOff?.current) setToggleOff(blockRefOff?.current?.getBoundingClientRect().top)

    return () => window.removeEventListener(Events.SCROLL, changeValue)
  }, [blockRef, blockRefOff, toggleOff, topPadding])

  return value
}

export default useToggleAfterScrollBlock
